import useModal from '../app/hooks/useModal';

const Modal = (): null | React.ReactElement => {
  const { modal } = useModal();

  return modal;
};

export default Modal;
